<template>
    <div v-html="require('!!html-loader!@/assets/styles/frontend-library/images/' + icon +'.svg')">
    </div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    addClass: {
      type: String,
      required: false,
      default: '',
    },
    dataCategory: {
      type: String,
      required: false,
      default: null,
    },
    dataEventlabel: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      required: false,
      type: Number,
      default: 24,
    },
  },
  data() {
    return {
      classes: '',
    };
  },
  mounted() {
    this.classes = `${this.addClass} ut-fill-current`;

    if (this.size) {
      this.$el.querySelector('svg').setAttribute('width', `${this.size}px`);
      this.$el.querySelector('svg').setAttribute('height', `${this.size}px`);
    }

    this.$el.querySelectorAll('svg').forEach((element) => {
      if (this.dataCategory) {
        element.classList = ['ga-event', element.classList].join(' ');
        element.setAttribute("data-category", this.dataCategory);
        element.setAttribute("data-eventlabel", this.dataEventlabel);
      };
    });  

    // Update all <path> with new classes
    this.$el.querySelectorAll('path').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const path = element;
        path.classList = this.classes;
        if (this.dataCategory) {
        path.classList = ['ga-event', path.classList ].join(' ');
        path.setAttribute("data-category", this.dataCategory);
        path.setAttribute("data-eventlabel", this.dataEventlabel);
        };
      }
    });

    // Update all <g> with new classes
    this.$el.querySelectorAll('g').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const g = element;
        g.classList = this.classes;
        if (this.dataCategory) {
        g.classList = ['ga-event', g.classList ].join(' ');
        g.setAttribute("data-category", this.dataCategory);
        g.setAttribute("data-eventlabel", this.dataEventlabel);
        };
      }
    });

    // Update all <ellipse> with new classes
    this.$el.querySelectorAll('ellipse').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const ellipse = element;
        ellipse.classList = this.classes;
        if (this.dataCategory) {
        ellipse.classList = ['ga-event', ellipse.classList ].join(' ');
        ellipse.setAttribute("data-category", this.dataCategory);
        ellipse.setAttribute("data-eventlabel", this.dataEventlabel);
        };
      }
    });

    // Update all <rect> with new classes
    this.$el.querySelectorAll('rect').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const rect = element;
        rect.classList = this.classes;
        if (this.dataCategory) {
        rect.classList = ['ga-event', rect.classList ].join(' ');
        rect.setAttribute("data-category", this.dataCategory);
        rect.setAttribute("data-eventlabel", this.dataEventlabel);
        };
      }
    });

    // Update all <circle> with new classes
    this.$el.querySelectorAll('circle').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const circle = element;
        circle.classList = this.classes;
        if (this.dataCategory) {
        circle.classList = ['ga-event', circle.classList ].join(' ');
        circle.setAttribute("data-category", this.dataCategory);
        circle.setAttribute("data-eventlabel", this.dataEventlabel);
        };
      }
    });

    // Update all <polygon> with new classes
    this.$el.querySelectorAll('polygon').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const polygon = element;
        polygon.classList = this.classes;
        if (this.dataCategory) {
        polygon.classList = ['ga-event', polygon.classList ].join(' ');
        polygon.setAttribute("data-category", this.dataCategory);
        polygon.setAttribute("data-eventlabel", this.dataEventlabel);
        };
      }
    });

    // Update all <polyline> with new classes
    this.$el.querySelectorAll('polyline').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const polyline = element;
        polyline.classList = this.classes;
        if (this.dataCategory) {
        polyline.classList = ['ga-event', polyline.classList ].join(' ');
        polyline.setAttribute("data-category", this.dataCategory);
        polyline.setAttribute("data-eventlabel", this.dataEventlabel);
        };
      }
    });
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">

</style>
